import { ButtonUtils, ControlState, FontUtils, GridUtils, Image3D, ImgButton, LayoutUtils, MeshUtils, Rectangle3D, ScrollViewer3D, TabControl, AnimatedOverflow, ObjectBuilder } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
import { TipMenuItemState } from "@dreamcam/web-sdk";
import { text } from "../../TextResources";
import { AppView } from "../AppView";
import { MeshName } from "../MeshName";
import { Container } from "@babylonjs/gui/2D/controls/container.js";
import { Button } from "@babylonjs/gui/2D/controls/button.js";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { TextWrapping } from "@babylonjs/gui/2D/controls/textBlock.js";
import { Vector2, Vector3 } from "@babylonjs/core/Maths/math.vector.js";
import { WebXRState } from "@babylonjs/core/XR/webXRTypes.js";
import { StringUtils } from "../utils/StringUtils";
import { ScrollHandler } from "../ScrollHandler";
import { XRInputHelper } from "../XRInputHelper";
const PRICE_WARNING_VALUE = 100;
// noinspection DuplicatedCode
export class BroadcastMenuTipMenu {
    constructor(menuMesh, menuFunctions, callbacks, messageDialog, sendTipDialog, dropdownSlider, 
    //    toyTipDialog: ToyTipDialog,
    loginDialog) {
        // private readonly _toyTipDialog: ToyTipDialog;
        this._isGuest = true;
        this._modelNickname = "";
        this._currentDropdownItem = null;
        this._currentDropdownPosition = null;
        this._hoveredToysMenuItem = null;
        this._pointerDownHandler = (_eventData, eventState) => {
            const itemContainer = eventState.currentTarget;
            const item = itemContainer.stuff?.item;
            const color = Env.broadcast.menu.tipMenu.item.color;
            itemContainer.background = item.isPrivate ? color.privatePressed : color.publicPressed;
        };
        this._pointerUpHandler = (_eventData, eventState) => {
            const downItem = eventState.currentTarget.stuff?.item;
            const upItem = eventState.target.stuff?.item;
            //TODO DZZ DCVR-2809
            // Иногда случается остаточная отрисовка hover! Надо бы снимать hover со всей станицы. Когда?...
            if (downItem === undefined || upItem === undefined) {
                // console.warn(`++++++++++++++++++++`);
                if (upItem === undefined) {
                    // const downItemInfo = downItem ? `, downItem=${downItem.description}` : "";
                    // console.warn(`upItem is undefined${downItemInfo}`);
                    this._unhoverAll();
                }
                // if (downItem === undefined) {
                //     const upItemInfo = upItem ? `, upItem=${upItem.description}` : "";
                //     console.warn(`downItem is undefined${upItemInfo}`);
                // }
                // console.warn(`++++++++++++++++++++`);
                return;
            }
            if (downItem.id === upItem.id) {
                eventState.currentTarget.pointerEnterAnimation();
            }
            else {
                eventState.currentTarget.pointerOutAnimation();
                eventState.target.pointerEnterAnimation();
            }
        };
        // private _getCoordinatesInTextureSpace(control: Control, localPoint: Vector2): Vector2 {
        //     const parent: Nullable<Container> = control.parent;
        //     if (parent) {
        //         const parentPoint: Vector2 = control.getParentLocalCoordinates(localPoint);
        //         return this._getCoordinatesInTextureSpace(parent, parentPoint);
        //     }
        //     return localPoint;
        // }
        this._onItemClickHandler = (eventData, eventState) => {
            if (eventData.buttonIndex !== 0)
                return;
            const itemContainer = eventState.currentTarget;
            const item = itemContainer.stuff?.item;
            if (item === undefined)
                return;
            const textureHeight = itemContainer.host.getSize().height;
            const deltaMeshY = (textureHeight / 2 - eventData.y) * Env.broadcast.menu.tipMenu.height / textureHeight;
            // this._mesh2D.mesh.updateFacetData();
            // const tipMenuAbsolutePosition = this._mesh2D.mesh.getAbsolutePosition();
            // const normal: Vector3 = this._mesh2D.mesh.getFacetNormal(0);
            // const delta = normal.scale(-Env.broadcast.menu.tipMenu.message.z).add(new Vector3(0, deltaMeshY, 0));
            const messageDialogAbsolutePosition = Vector3.TransformCoordinates(new Vector3(0, deltaMeshY, -0.01), this._mesh2D.mesh._localMatrix);
            if (item.state === TipMenuItemState.PrivateLocked && !this._isGuest) {
                this._messageDialog.openPrivateMessage(messageDialogAbsolutePosition, this._mesh2D.mesh.rotationQuaternion ?? this._mesh2D.mesh.rotation.toQuaternion(), () => {
                    this._messageDialog.hide();
                    this._menuFunctions.setPrivateShowPanelVisibility(true);
                    // this._menuFunctions.animateModePanel();
                });
                return;
            }
            if (this._isGuest) {
                this._messageDialog.openSignInMessage(messageDialogAbsolutePosition, this._mesh2D.mesh.rotationQuaternion ?? this._mesh2D.mesh.rotation.toQuaternion(), async () => {
                    this._messageDialog.hide();
                    if (AppView.getInstance().isApiAuth)
                        this._loginDialog.show();
                    else
                        await AppView.getInstance().loginAsync();
                });
                return;
            }
            if (this._balanceAmount !== undefined && this._balanceAmount < item.price) {
                this._messageDialog.openTopUpMessage(messageDialogAbsolutePosition, this._mesh2D.mesh.rotationQuaternion ?? this._mesh2D.mesh.rotation.toQuaternion(), async () => {
                    this._messageDialog.hide();
                    //this._menuFunctions.animateClientPanel();
                    await AppView.getInstance().topUpAsync();
                });
                return;
            }
            if (item.price > PRICE_WARNING_VALUE) {
                this._sendTipDialog.openMessage(messageDialogAbsolutePosition, item, (x) => {
                    this._sendTipDialog.hide();
                    this._buyTipMenuItem(x);
                });
                return;
            }
            this._buyTipMenuItem(item);
        };
        this._mesh2D = menuMesh;
        this._menuFunctions = menuFunctions;
        this._callbacks = callbacks;
        this._messageDialog = messageDialog;
        this._sendTipDialog = sendTipDialog;
        this._dropdownSlider = dropdownSlider;
        // this._toyTipDialog = toyTipDialog;
        this._loginDialog = loginDialog;
        this._scrollHandler = new ScrollHandler([MeshName.broadcastMenuPanelTipMenu], this._mesh2D.m2px(Env.broadcast.menu.tipMenu.scrollView.speed), (v) => {
            if (this._tipMenuScrollViewer !== undefined && this._tipMenuInnerContainer.isVisible)
                this._tipMenuScrollViewer.verticalValue = Math.max(Math.min(this._tipMenuScrollViewer.verticalValue + v / (this._tipMenuScrollViewer.children[0].heightInPixels - this._tipMenuScrollViewer.heightInPixels), 1), 0);
            else if (this._toysMenuScrollViewer !== undefined && this._toysMenuInnerContainer.isVisible)
                this._toysMenuScrollViewer.verticalValue = Math.max(Math.min(this._toysMenuScrollViewer.verticalValue + v / (this._toysMenuScrollViewer.children[0].heightInPixels - this._toysMenuScrollViewer.heightInPixels), 1), 0);
        });
        const pointerAddon = XRInputHelper.addPointerAddon(this._mesh2D);
        pointerAddon.onPointerOut.add(() => {
            this._scrollHandler.stopScroll();
        });
        this._dropdownSlider.onPointerEnter.add(() => {
            if (this._toysMenuItemleaveTimeout !== undefined)
                clearTimeout(this._toysMenuItemleaveTimeout);
        });
        this._dropdownSlider.onPointerLeave.add(() => {
            this._toysMenuItemleaveTimeout = setTimeout(() => this.hideDropdown(), Env.broadcast.menu.tipMenu.toysMenuItem.dropdown.leaveTimeout);
        });
        // By default, the panel is hidden.
        this.isVisible = false;
        const rootPanelContainer = this._createRootPanel();
        const tipMenuTab = this._createTipMenuContainer(rootPanelContainer);
        this._tipMenuOuterContainer = tipMenuTab.outerContainer;
        this._tipMenuEmptyContainer = tipMenuTab.emptyContainer;
        this._activitiesEmptyText = tipMenuTab.emptyContainerTextBlock;
        this._tipMenuScrollViewer = tipMenuTab.scrollViewer;
        this._tipMenuInnerContainer = tipMenuTab.innerContainer;
        const toysMenuTab = this._createToysMenuContainer(rootPanelContainer);
        this._toysMenuOuterContainer = toysMenuTab.outerContainer;
        this._toysMenuEmptyContainer = toysMenuTab.emptyContainer;
        this._toysEmptyText = toysMenuTab.emptyContainerTextBlock;
        this._toysMenuScrollViewer = toysMenuTab.scrollViewer;
        this._toysMenuInnerContainer = toysMenuTab.innerContainer;
        this._createTabs(rootPanelContainer, this._tipMenuOuterContainer, this._toysMenuOuterContainer);
        this._tipMenuOuterContainer.isVisible = true;
        this._toysMenuOuterContainer.isVisible = false;
    }
    openTab(index) {
        this._tabControl.currentTab = index;
    }
    _addTipMenuItemToContainer(item, parent) {
        const it = Env.broadcast.menu.tipMenu.item;
        const itemContainer = new Button(`tipMenuItem${item.id}`);
        const stuff = {
            item: item,
            itemContainer: itemContainer,
            isHover: false,
            descriptionTextBlock: undefined,
            lockImage: undefined,
            priceTextBlock: undefined,
            currencyImage: undefined,
        };
        item.stuff = stuff;
        itemContainer.stuff = stuff;
        itemContainer.widthInPixels = this._mesh2D.m2px(Env.broadcast.menu.tipMenu.width);
        itemContainer.heightInPixels = this._mesh2D.m2px(it.defaultHeight);
        itemContainer.background = it.color.normal;
        itemContainer.thickness = 0;
        itemContainer.pointerDownAnimation = () => { }; // Turns off button scaling.
        itemContainer.pointerUpAnimation = () => { }; // Turns off button scaling.
        itemContainer.pointerEnterAnimation = () => {
            const stuff = itemContainer.stuff;
            this._setItemStyle(stuff, true);
        };
        itemContainer.pointerOutAnimation = () => {
            const stuff = itemContainer.stuff;
            this._setItemStyle(stuff, false);
        };
        // itemContainer.onPointerMoveObservable.add(this._pointerMoveHandler);
        itemContainer.onPointerDownObservable.add(this._pointerDownHandler);
        itemContainer.onPointerUpObservable.add(this._pointerUpHandler);
        itemContainer.onPointerClickObservable.add(this._onItemClickHandler);
        const rowStackPanel = new StackPanel(`tipMenuItemRow${item.id}`);
        rowStackPanel.isVertical = false;
        rowStackPanel.heightInPixels = this._mesh2D.m2px(it.defaultHeight);
        rowStackPanel.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
        rowStackPanel.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        itemContainer.addControl(rowStackPanel);
        const gap2 = this._addGap(rowStackPanel, it.gaps.gap2);
        const lockImage = this._addLock(rowStackPanel, item);
        const gap3 = this._addGap(rowStackPanel, it.gaps.gap3);
        const priceTextBlock = this._addPrice(rowStackPanel, item);
        const gap4 = this._addGap(rowStackPanel, it.gaps.gap4);
        const currencyImage = this._addCurrency(rowStackPanel, item);
        const gap5 = this._addGap(rowStackPanel, it.gaps.gap5);
        stuff.descriptionTextBlock = this._addDescription(stuff.itemContainer, item, 512);
        stuff.lockImage = lockImage;
        stuff.priceTextBlock = priceTextBlock;
        stuff.currencyImage = currencyImage;
        const descriptionLeftInPixels = this._mesh2D.m2px(it.gaps.gap1);
        const descriptionTopInPixels = this._mesh2D.m2px(it.description.top);
        priceTextBlock.stuff = stuff;
        priceTextBlock.onLinesReadyObservable.add((textBlock, _eventState) => {
            const stuff = textBlock.stuff;
            if (stuff.descriptionTextBlock !== undefined) {
                stuff.descriptionTextBlock.leftInPixels = descriptionLeftInPixels;
                stuff.descriptionTextBlock.topInPixels = descriptionTopInPixels;
                stuff.descriptionTextBlock.widthInPixels = stuff.itemContainer.widthInPixels - descriptionLeftInPixels -
                    gap2.widthInPixels - lockImage.widthInPixels - gap3.widthInPixels - textBlock.widthInPixels -
                    gap4.widthInPixels - currencyImage.widthInPixels - gap5.widthInPixels;
            }
        });
        stuff.descriptionTextBlock.stuff = stuff;
        stuff.descriptionTextBlock.onLinesReadyObservable.add((textBlock) => {
            const stuff = textBlock.stuff;
            stuff.itemContainer.heightInPixels = textBlock.heightInPixels + 2 * descriptionTopInPixels;
        });
        this._setItemStyle(stuff, false);
        parent.addControl(itemContainer);
    }
    _addToysMenuItemToContainer(item, parent) {
        const it = Env.broadcast.menu.tipMenu.toysMenuItem;
        const itemButton = ButtonUtils.CreateImgButton(`toysMenuItemButton${item.id}`, it.buttonLayout, this._mesh2D);
        itemButton.widthInPixels = this._mesh2D.m2px(Env.broadcast.menu.tipMenu.width);
        itemButton.heightInPixels = this._mesh2D.m2px(it.height);
        const itemContainer = GridUtils.CreateGrid(`toysMenuItem${item.id}`, it.gridLayout, this._mesh2D);
        itemContainer.widthInPixels = this._mesh2D.m2px(Env.broadcast.menu.tipMenu.width);
        itemContainer.heightInPixels = this._mesh2D.m2px(it.height);
        itemContainer.paddingLeftInPixels = this._mesh2D.m2px(it.padding.left);
        itemContainer.paddingRightInPixels = this._mesh2D.m2px(it.padding.right);
        itemButton.addControl(itemContainer);
        const icon = new Image3D(`toysMenuItemicon${item.id}`, it.icon.getToysMenuItemIcon(item.modeDefined, item.vibration));
        icon.widthInPixels = this._mesh2D.m2px(it.icon.width);
        icon.heightInPixels = this._mesh2D.m2px(it.icon.height);
        itemContainer.addControl(icon, 0, 0);
        const vibration = ObjectBuilder.createTextBlock3D(this._mesh2D, `toysMenuItemVibration${item.id}`, item.title, it.vibration);
        vibration.color = it.vibration.getToysMenuItemColor(item.vibration);
        itemContainer.addControl(vibration, 0, 1);
        const duration = ObjectBuilder.createTextBlock3D(this._mesh2D, `toysMenuItemDuration${item.id}`, item.duration === 0
            ? text.broadcast_menu_tipMenu_toysDurationIsZero
            : StringUtils.stringFormat(text.broadcast_menu_tipMenu_toysDurationIsNonZero, item.duration), it.duration);
        itemContainer.addControl(duration, 0, 2);
        let currentValue = item.token_min;
        if (item.token_max !== undefined && item.token_max !== null && item.token_min !== item.token_max)
            currentValue = Math.ceil(item.token_min + (item.token_max - item.token_min) * 0.7);
        else if (item.token_max === undefined || item.token_max === null)
            currentValue = Math.ceil(item.token_min * 1.5);
        const itemView = { ...item, currentValue, isRange: (item.token_max !== undefined && item.token_max !== null && item.token_min !== item.token_max) || item.token_max === undefined || item.token_max === null };
        const price = ObjectBuilder.createTextBlock3D(this._mesh2D, `toysMenuItemPrice${item.id}`, `${itemView.currentValue}`, it.price);
        const priceContainer = new Container("priceContainer");
        priceContainer.widthInPixels = this._mesh2D.m2px(it.priceContainer.width);
        const overflow = new AnimatedOverflow(price);
        overflow.overflowType = "width";
        overflow.overtravel = this._mesh2D.m2px(it.priceContainer.overtravel);
        overflow.animationSpeed = it.priceContainer.speed;
        priceContainer.addControl(price);
        const cp = Env.broadcast.menu.tipMenu.item.currency;
        const currency = new Image3D(`toysMenuItem${item.id}_currency`, cp.image);
        currency.widthInPixels = this._mesh2D.m2px(cp.width);
        currency.heightInPixels = this._mesh2D.m2px(cp.height);
        // currency.topInPixels = this._mesh2D.m2px(cp.top);
        currency.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        currency.verticalAlignment = Control.VERTICAL_ALIGNMENT_CENTER;
        let dropdownButton = null;
        if (itemView.isRange) {
            const dd = Env.broadcast.menu.tipMenu.toysMenuItem.dropdown.button;
            dropdownButton = ButtonUtils.CreateImgToggleButton("dropdownButton", dd.layout, this._mesh2D);
            dropdownButton.isPointerBlocker = true;
            // dropdownButton.adaptWidthToChildren = true;
            dropdownButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
            const dropdownStackPanel = new StackPanel("dropdownStackPanel");
            dropdownStackPanel.isVertical = false;
            dropdownStackPanel.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
            dropdownStackPanel.verticalAlignment = Control.VERTICAL_ALIGNMENT_CENTER;
            dropdownStackPanel.paddingRightInPixels = this._mesh2D.m2px(dd.padding.right);
            dropdownStackPanel.paddingLeftInPixels = this._mesh2D.m2px(dd.padding.left);
            dropdownStackPanel.spacing = this._mesh2D.m2px(dd.spacing);
            dropdownStackPanel.addControl(priceContainer);
            dropdownStackPanel.addControl(currency);
            const da = Env.broadcast.menu.tipMenu.toysMenuItem.downArrow;
            const arrow = new Image3D("dropdownArrow", da.image, true);
            arrow.stateController.addState("toggled", da.flippedImage);
            arrow.stateController.addState("toggledHover", da.flippedImage);
            arrow.stateController.addState("toggledPressed", da.flippedImage);
            arrow.widthInPixels = this._mesh2D.m2px(da.width);
            arrow.heightInPixels = this._mesh2D.m2px(da.height);
            dropdownStackPanel.addControl(arrow);
            dropdownButton.addControl(dropdownStackPanel);
            itemContainer.addControl(dropdownButton, 0, 3, 1, 3);
            dropdownButton.onIsToggledChangedObservable.add((v) => {
                if (v) {
                    if (this._hoveredToysMenuItem !== itemButton)
                        this._hoveredToysMenuItem?.stateController.changeState("normal");
                    this._hoveredToysMenuItem = itemButton;
                    itemButton.stateController.changeState("hover");
                    // dropdownButton.stateController.changeState("selfHover");
                    setTimeout(() => {
                        const coord = itemContainer.getParentLocalCoordinates(Vector2.Zero());
                        this._showDropdown(itemView, price, itemContainer, coord.y);
                        if (this._toysMenuItemleaveTimeout !== undefined)
                            clearTimeout(this._toysMenuItemleaveTimeout);
                    }, 0);
                }
                else {
                    this.hideDropdown();
                }
            });
            dropdownButton.onPointerOutObservable.add(() => {
                // dropdownButton.stateController.changeState(itemButton.stateController.state);
                this._toysMenuItemleaveTimeout = setTimeout(() => {
                    if (dropdownButton !== null)
                        dropdownButton.isToggled = false;
                }, Env.broadcast.menu.tipMenu.toysMenuItem.dropdown.leaveTimeout);
            });
            // dropdownButton.onPointerDownObservable.add(() =>
            // {
            //     dropdownButton.stateController.changeState("selfPressed");
            // });
            // dropdownButton.onPointerUpObservable.add(() => {
            //     dropdownButton.stateController.changeState("selfHover");
            // });
        }
        else {
            itemContainer.addControl(priceContainer, 0, 3);
            itemContainer.addControl(currency, 0, 4);
        }
        itemButton.onPointerEnterObservable.add(() => {
            if (this._hoveredToysMenuItem !== itemButton) {
                if (dropdownButton !== null)
                    dropdownButton.isToggled = false;
                this._hoveredToysMenuItem?.stateController.changeState("normal");
            }
            this._hoveredToysMenuItem = itemButton;
            overflow.startAnimation();
        });
        itemButton.onPointerOutObservable.add(() => overflow.stopAnimation());
        itemButton.onPointerClickObservable.add(async (e) => await this.sendToysTip(e, itemView, itemContainer));
        parent.addControl(itemButton);
    }
    // private static _getPriceText(min: number, max?: number): string {
    //     if (max === undefined || max === null)
    //         return StringUtils.stringFormat(text.broadcast_menu_tipMenu_toysPriceNoMax, min);
    //     if (max === min)
    //         return StringUtils.stringFormat(text.broadcast_menu_tipMenu_toysPriceSameMinMax, min);
    //     return StringUtils.stringFormat(text.broadcast_menu_tipMenu_toysPriceInterval, min, max);
    // }
    async sendToysTip(eventData, item, itemContainer) {
        const textureHeight = itemContainer.host.getSize().height;
        const deltaMeshY = (textureHeight / 2 - eventData.y) * Env.broadcast.menu.tipMenu.height / textureHeight;
        const messageDialogAbsolutePosition = Vector3.TransformCoordinates(new Vector3(0, deltaMeshY, Env.broadcast.menu.tipMenu.message.z), this._mesh2D.mesh._localMatrix);
        if (this._isGuest) {
            this._messageDialog.openSignInMessage(messageDialogAbsolutePosition, this._mesh2D.mesh.rotationQuaternion ?? this._mesh2D.mesh.rotation.toQuaternion(), async () => {
                this._messageDialog.hide();
                if (AppView.getInstance().isApiAuth)
                    this._loginDialog.show();
                else
                    await AppView.getInstance().loginAsync();
            });
            return;
        }
        const tipDialogAbsolutePosition = messageDialogAbsolutePosition.add(new Vector3(0, 0, -0.01));
        // this._toyTipDialog.openMessage(messageDialogAbsolutePosition, item, async (v) => {
        //     if (this._balanceAmount !== undefined && this._balanceAmount < v) {
        //         this._messageDialog.openTopUpMessage(tipDialogAbsolutePosition, this._mesh2D.mesh.rotationQuaternion ?? this._mesh2D.mesh.rotation.toQuaternion(), async () => {
        //             this._messageDialog.hide();
        //             //this._menuFunctions.animateClientPanel();
        //             await AppView.getInstance().topUpAsync();
        //         });
        //         return;
        //     }
        //     this._toyTipDialog.hide();
        //     await this._callbacks.buyToysMenuItemAsync(item.id,v);
        // });
        if (this._balanceAmount !== undefined && this._balanceAmount < item.currentValue) {
            this._messageDialog.openTopUpMessage(tipDialogAbsolutePosition, this._mesh2D.mesh.rotationQuaternion ?? this._mesh2D.mesh.rotation.toQuaternion(), async () => {
                this._messageDialog.hide();
                //this._menuFunctions.animateClientPanel();
                await AppView.getInstance().topUpAsync();
            });
            return;
        }
        await this._callbacks.buyToysMenuItemAsync(item.id, item.currentValue);
    }
    _getMaxValue(item) {
        if (item.token_max !== undefined && item.token_max !== null)
            return item.token_max;
        else if (this._isGuest)
            return Env.broadcast.menu.tipMenu.toysMenuItem.dropdown.maxValue;
        else if (this._balanceAmount !== undefined && this._balanceAmount > item.token_min)
            return this._balanceAmount;
        return Env.broadcast.menu.tipMenu.toysMenuItem.dropdown.maxValue;
    }
    _showDropdown(item, priceText, itemContainer, y) {
        const textureHeight = itemContainer.host.getSize().height;
        const deltaMeshY = this._mesh2D.px2m(textureHeight / 2 + y - itemContainer.heightInPixels) - this._dropdownSlider.height / 2;
        const dropdownPosition = new Vector3(0, deltaMeshY, Env.broadcast.menu.tipMenu.message.z);
        if (this._dropdownSlider.isVisible && this._currentDropdownItem === item && dropdownPosition.y === this._currentDropdownPosition?.y)
            return;
        this._currentDropdownItem = item;
        this._currentDropdownPosition = dropdownPosition;
        const max = this._getMaxValue(item);
        this._dropdownSlider.show(dropdownPosition, { min: item.token_min, max, current: item.currentValue }, async (v) => {
            item.currentValue = Math.ceil(v);
            priceText.text = `${item.currentValue}`;
        });
    }
    hideDropdown() {
        this._dropdownSlider.hide();
        this._currentDropdownItem = null;
        this._currentDropdownPosition = null;
    }
    _setItemStyle(stuff, isHover) {
        const it = Env.broadcast.menu.tipMenu.item;
        const item = stuff.item;
        // A patch in case some row is freezed in hover state:
        if (isHover && !stuff.isHover)
            this._unhoverAll();
        stuff.isHover = isHover;
        stuff.itemContainer.background = isHover
            ? item.isPrivate && item.state === TipMenuItemState.PrivateLocked ? it.color.privateHover : it.color.publicHover
            : stuff.itemContainer.background = it.color.normal;
        if (stuff.descriptionTextBlock)
            BroadcastMenuTipMenu._setTextBlockColor(stuff.descriptionTextBlock, item, isHover, it.description.color);
        if (stuff.lockImage)
            this._setLockImage(stuff.lockImage, item);
        if (stuff.priceTextBlock)
            BroadcastMenuTipMenu._setTextBlockColor(stuff.priceTextBlock, item, isHover, it.price.color);
    }
    _unhoverAll() {
        if (this._tipMenu === undefined)
            return;
        for (let item of this._tipMenu) {
            const stuff = item.stuff;
            if (stuff && stuff.isHover)
                this._setItemStyle(stuff, false);
        }
    }
    static _setTextBlockColor(textBlock, tipMenuItem, isHover, colorPresentation) {
        textBlock.color = isHover
            ? tipMenuItem.isPrivate ? colorPresentation.privateHover : colorPresentation.publicHover
            : colorPresentation.normal;
    }
    _setLockImage(image, tipMenuItem) {
        const lock = Env.broadcast.menu.tipMenu.item.lock;
        const lockImages = lock.images;
        switch (tipMenuItem.state) {
            case TipMenuItemState.Public:
                image.source = null;
                image.widthInPixels = 0;
                image.isVisible = false;
                break;
            case TipMenuItemState.PrivateLocked:
                image.source = lockImages.lockedNormal;
                image.widthInPixels = this._mesh2D.m2px(lock.width);
                image.isVisible = true;
                break;
            case TipMenuItemState.PrivateUnlocked:
                image.source = lockImages.unlockedNormal;
                image.widthInPixels = this._mesh2D.m2px(lock.width);
                image.isVisible = true;
                break;
        }
    }
    _addGap(parent, widthInMeters) {
        const result = new Container("gap");
        result.heightInPixels = 1;
        result.widthInPixels = this._mesh2D.m2px(widthInMeters);
        result.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
        result.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        parent.addControl(result);
        return result;
    }
    _addDescription(parent, item, widthInPixels) {
        const presentation = Env.broadcast.menu.tipMenu.item.description;
        const result = ObjectBuilder.createTextBlock3D(undefined, `tipMenuItem${item.id}_description`, `${item.description}`, {
            resizeToFit: true,
            textWrapping: TextWrapping.WordWrap,
            width: widthInPixels,
            horizontalAlignment: Control.HORIZONTAL_ALIGNMENT_LEFT,
            verticalAlignment: Control.VERTICAL_ALIGNMENT_TOP,
            textHorizontalAlignment: Control.HORIZONTAL_ALIGNMENT_LEFT,
            textVerticalAlignment: Control.VERTICAL_ALIGNMENT_TOP,
            padding: presentation.padding,
            color: presentation.color.normal,
            fontSize: this._mesh2D.m2px(presentation.fontSize),
            fontWeight: presentation.fontWeight,
        });
        parent.addControl(result);
        return result;
    }
    _addCurrency(parent, item) {
        const presentation = Env.broadcast.menu.tipMenu.item.currency;
        const result = new Image3D(`tipMenuItem${item.id}_currency`, presentation.image);
        result.widthInPixels = this._mesh2D.m2px(presentation.width);
        result.heightInPixels = this._mesh2D.m2px(presentation.height);
        result.topInPixels = this._mesh2D.m2px(presentation.top);
        result.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
        result.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        parent.addControl(result);
        return result;
    }
    _addLock(parent, item) {
        const presentation = Env.broadcast.menu.tipMenu.item.lock;
        const result = new Image3D(`tipMenuItem${item.id}_lock`);
        result.widthInPixels = this._mesh2D.m2px(presentation.width);
        result.heightInPixels = this._mesh2D.m2px(presentation.height);
        result.topInPixels = this._mesh2D.m2px(presentation.top);
        result.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
        result.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        parent.addControl(result);
        return result;
    }
    _addPrice(parent, item) {
        const presentation = Env.broadcast.menu.tipMenu.item.price;
        const result = ObjectBuilder.createTextBlock3D(this._mesh2D, `tipMenuItem${item.id}_price`, `${item.price}`, {
            resizeToFit: true,
            height: presentation.height,
            top: presentation.top,
            horizontalAlignment: Control.HORIZONTAL_ALIGNMENT_RIGHT,
            verticalAlignment: Control.VERTICAL_ALIGNMENT_TOP,
            textHorizontalAlignment: Control.HORIZONTAL_ALIGNMENT_RIGHT,
            textVerticalAlignment: Control.VERTICAL_ALIGNMENT_TOP,
            padding: presentation.padding,
            color: presentation.color.normal,
            fontSize: presentation.fontSize,
            fontWeight: presentation.fontWeight,
        });
        parent.addControl(result);
        return result;
    }
    _buyTipMenuItem(item) {
        (async () => {
            await this._callbacks.sendTipMenuItemRequestAsync(item.id);
        })();
    }
    _createTipMenuContainer(_parent) {
        const tm = Env.broadcast.menu.tipMenu;
        const emptyContainer = new Container("tipMenuEmptyContainer");
        emptyContainer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        const icon = new Image3D("tipMenuEmptyIcon", tm.empty.icon.activities);
        icon.topInPixels = this._mesh2D.m2px(tm.empty.icon.top);
        icon.widthInPixels = this._mesh2D.m2px(tm.empty.icon.width);
        icon.heightInPixels = this._mesh2D.m2px(tm.empty.icon.height);
        icon.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        emptyContainer.addControl(icon);
        emptyContainer.addControl(ObjectBuilder.createTextBlock3D(this._mesh2D, "tipMenuEmptyLine1", text.broadcast_menu_tipMenu_emptyPanel_activities_line1, tm.empty.line1));
        const emptyContainerTextBlock = ObjectBuilder.createTextBlock3D(this._mesh2D, "tipMenuEmptyLine2", StringUtils.stringFormat(text.broadcast_menu_tipMenu_emptyPanel_activities_line2, this._modelNickname), tm.empty.line2);
        emptyContainer.addControl(emptyContainerTextBlock);
        const outerContainer = new Container("tipMenuPanelContainer");
        outerContainer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        outerContainer.isVisible = false;
        outerContainer.background = Env.broadcast.menu.backgroundColor;
        outerContainer.addControl(emptyContainer);
        const scrollViewer = new ScrollViewer3D("tipMenuScrollViewer");
        scrollViewer.color = tm.scrollView.colors.background;
        scrollViewer.barColor = tm.scrollView.colors.bar;
        scrollViewer.hoverBarColor = tm.scrollView.colors.hoverBar;
        scrollViewer.pressedBarColor = tm.scrollView.colors.pressedBar;
        scrollViewer.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        scrollViewer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        scrollViewer.verticalBarPaddingInPixels = {
            left: this._mesh2D.m2px(tm.scrollView.verticalBar.padding.left),
            right: this._mesh2D.m2px(tm.scrollView.verticalBar.padding.right),
            top: this._mesh2D.m2px(tm.scrollView.verticalBar.padding.top),
            bottom: this._mesh2D.m2px(tm.scrollView.verticalBar.padding.bottom)
        };
        scrollViewer.barSizeInPixels = this._mesh2D.m2px(tm.scrollView.verticalBar.size);
        this._scrollHandler.releaseThumbstickAxesChangedListener();
        this._scrollHandler.addThumbstickAxesChangedListener();
        scrollViewer.valueToScrollTo = 0;
        outerContainer.addControl(scrollViewer);
        const innerContainer = new StackPanel("tipMenuStackPanel");
        innerContainer.isVertical = true;
        innerContainer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        scrollViewer.addControl(innerContainer);
        return {
            outerContainer,
            emptyContainer,
            emptyContainerTextBlock,
            scrollViewer,
            innerContainer,
        };
    }
    _createToysMenuContainer(_parent) {
        const tm = Env.broadcast.menu.tipMenu;
        const emptyContainer = new Container("_toysMenuEmptyContainer");
        emptyContainer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        const icon = new Image3D("toysMenuEmptyIcon", tm.empty.icon.toys);
        icon.topInPixels = this._mesh2D.m2px(tm.empty.icon.top);
        icon.widthInPixels = this._mesh2D.m2px(tm.empty.icon.width);
        icon.heightInPixels = this._mesh2D.m2px(tm.empty.icon.height);
        icon.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        emptyContainer.addControl(icon);
        emptyContainer.addControl(ObjectBuilder.createTextBlock3D(this._mesh2D, "toysMenuEmptyLine1", text.broadcast_menu_tipMenu_emptyPanel_toys_line1, tm.empty.line1));
        const emptyContainerTextBlock = ObjectBuilder.createTextBlock3D(this._mesh2D, "toysMenuEmptyLine2", StringUtils.stringFormat(text.broadcast_menu_tipMenu_emptyPanel_toys_line2, this._modelNickname), tm.empty.line2);
        emptyContainer.addControl(emptyContainerTextBlock);
        const outerContainer = new Container("toysMenuPanelContainer");
        outerContainer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        outerContainer.background = Env.broadcast.menu.backgroundColor;
        outerContainer.addControl(emptyContainer);
        const scrollViewer = new ScrollViewer3D("toysMenuScrollViewer");
        scrollViewer.color = tm.scrollView.colors.background;
        scrollViewer.barColor = tm.scrollView.colors.bar;
        scrollViewer.hoverBarColor = tm.scrollView.colors.hoverBar;
        scrollViewer.pressedBarColor = tm.scrollView.colors.pressedBar;
        scrollViewer.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        scrollViewer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        scrollViewer.verticalBarPaddingInPixels = {
            left: this._mesh2D.m2px(tm.scrollView.verticalBar.padding.left),
            right: this._mesh2D.m2px(tm.scrollView.verticalBar.padding.right),
            top: this._mesh2D.m2px(tm.scrollView.verticalBar.padding.top),
            bottom: this._mesh2D.m2px(tm.scrollView.verticalBar.padding.bottom)
        };
        scrollViewer.barSizeInPixels = this._mesh2D.m2px(tm.scrollView.verticalBar.size);
        this._scrollHandler.releaseThumbstickAxesChangedListener();
        this._scrollHandler.addThumbstickAxesChangedListener();
        scrollViewer.valueToScrollTo = 0;
        outerContainer.addControl(scrollViewer);
        const innerContainer = new StackPanel("tipMenuStackPanel");
        innerContainer.isVertical = true;
        innerContainer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        scrollViewer.addControl(innerContainer);
        return {
            outerContainer,
            emptyContainer,
            emptyContainerTextBlock,
            scrollViewer,
            innerContainer,
        };
    }
    _createRootPanel() {
        const m = Env.broadcast.menu;
        const tm = m.tipMenu;
        const rootPanelContainer = new Rectangle3D("tipMenuPanelContainer");
        rootPanelContainer.cornerRadius = this._mesh2D.m2px(m.cornerRadius);
        rootPanelContainer.thickness = 0;
        rootPanelContainer.background = tm.header.background;
        this._mesh2D.texture.addControl(rootPanelContainer);
        const caption = ObjectBuilder.createTextBlock3D(this._mesh2D, "tipMenuHeaderCaption", text.broadcast_menu_tipMenu_panelCaption, tm.header.caption);
        rootPanelContainer.addControl(caption);
        const closeButton = new ImgButton("tipMenuPanelClosePanel", tm.header.closeButton.imageLayout);
        closeButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
        closeButton.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        closeButton.widthInPixels = this._mesh2D.m2px(tm.header.closeButton.width);
        closeButton.heightInPixels = this._mesh2D.m2px(tm.header.closeButton.height);
        closeButton.paddingLeftInPixels = this._mesh2D.m2px(tm.header.closeButton.padding.left);
        closeButton.paddingRightInPixels = this._mesh2D.m2px(tm.header.closeButton.padding.right);
        closeButton.paddingTopInPixels = this._mesh2D.m2px(tm.header.closeButton.padding.top);
        closeButton.paddingBottomInPixels = this._mesh2D.m2px(tm.header.closeButton.padding.bottom);
        closeButton.onClickObserver.add(() => {
            setTimeout(() => {
                this.isVisible = false;
                this._menuFunctions.updateTipMenuButtonLayout();
            }, 0);
        });
        rootPanelContainer.addControl(closeButton);
        return rootPanelContainer;
    }
    _createTabs(parent, tipMenuContainer, toysMenuContainer) {
        const m = Env.broadcast.menu;
        const tm = m.tipMenu;
        this._tabControl = new TabControl("tipsMenuToysMenuTabs");
        this._tabControl.background = "transparent";
        this._tabControl.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        // this._tabControl.widthInPixels = this._mesh2D.m2px(tm.header.tabs.width);
        this._tabControl.heightInPixels = this._mesh2D.m2px(tm.header.tabs.height);
        this._tabControl.topInPixels = this._mesh2D.m2px(tm.header.tabs.top);
        parent.addControl(this._tabControl);
        const tipMenuCaption = ObjectBuilder.createTextBlock3D(this._mesh2D, "TipMenuTab", text.broadcast_menu_tipMenu_activitiesButton, tm.header.tabs.unselectedTabFontStyle);
        this._tabControl.addControl(tipMenuContainer, tipMenuCaption, LayoutUtils.GetButtonLayout(tm.header.tabs.buttonLayout, this._mesh2D));
        tipMenuCaption.stateController.setStates([
            { state: ControlState.ToggledHover, style: FontUtils.getAdjustedFontStyle(tm.header.tabs.selectedTabFontStyle, this._mesh2D) },
            { state: ControlState.Toggled, style: FontUtils.getAdjustedFontStyle(tm.header.tabs.selectedTabFontStyle, this._mesh2D) },
            { state: ControlState.ToggledPressed, style: FontUtils.getAdjustedFontStyle(tm.header.tabs.selectedTabFontStyle, this._mesh2D) },
        ]);
        const toysMenuCaption = ObjectBuilder.createTextBlock3D(this._mesh2D, "ToysMenuTab", text.broadcast_menu_tipMenu_toysButton, tm.header.tabs.unselectedTabFontStyle);
        toysMenuCaption.stateController.setStates([
            { state: ControlState.ToggledHover, style: FontUtils.getAdjustedFontStyle(tm.header.tabs.selectedTabFontStyle, this._mesh2D) },
            { state: ControlState.Toggled, style: FontUtils.getAdjustedFontStyle(tm.header.tabs.selectedTabFontStyle, this._mesh2D) },
            { state: ControlState.ToggledPressed, style: FontUtils.getAdjustedFontStyle(tm.header.tabs.selectedTabFontStyle, this._mesh2D) },
        ]);
        this._tabControl.addControl(toysMenuContainer, toysMenuCaption, LayoutUtils.GetButtonLayout(tm.header.tabs.buttonLayout, this._mesh2D));
        this._tabControl.onTabChangedObservable.add((eventData, _eventState) => {
            const isTipMenu = eventData === 0;
            const isToysMenu = eventData === 1;
            if (isTipMenu)
                this._updateTipMenu();
            if (isToysMenu)
                this._updateToysMenu();
        });
    }
    get isVisible() {
        return this._mesh2D.mesh.isVisible;
    }
    set isVisible(value) {
        if (this.isVisible === value)
            return;
        if (value) {
            this._menuFunctions.updateMenuPosition();
            this._scrollHandler.addThumbstickAxesChangedListener();
        }
        else {
            this._messageDialog.hide();
            this._sendTipDialog.hide();
            this.hideDropdown();
            // this._toyTipDialog.hide();
            this._scrollHandler.releaseThumbstickAxesChangedListener();
        }
        MeshUtils.setVisibility(this._mesh2D, value);
    }
    webXRStateChanged(state) {
        if (state === WebXRState.IN_XR) {
            this._scrollHandler.addThumbstickAxesChangedListener();
        }
        else {
            this._scrollHandler.releaseThumbstickAxesChangedListener();
        }
    }
    outputTipMenu(tipMenuEnabled, tipMenu) {
        this._tipMenuEnabled = tipMenuEnabled;
        this._tipMenu = tipMenu;
        this._messageDialog.hide();
        this._sendTipDialog.hide();
        this.hideDropdown();
        // this._toyTipDialog.hide();
        this._updateTipMenu();
    }
    outputToysMenu(toysMenu) {
        this._toysMenu = toysMenu;
        this._messageDialog.hide();
        this._sendTipDialog.hide();
        this.hideDropdown();
        // this._toyTipDialog.hide();
        this._updateToysMenu();
    }
    outputClientBalance(tokens) {
        this._balanceAmount = tokens;
    }
    outputModelNickname(nickname) {
        this._modelNickname = nickname;
        if (this._activitiesEmptyText)
            this._activitiesEmptyText.text = StringUtils.stringFormat(text.broadcast_menu_tipMenu_emptyPanel_activities_line2, nickname);
        if (this._toysEmptyText)
            this._toysEmptyText.text = StringUtils.stringFormat(text.broadcast_menu_tipMenu_emptyPanel_toys_line2, nickname);
    }
    stateChanged(_state, isGuest, _reason) {
        this._isGuest = isGuest;
    }
    _addEmptyRow(innerContainer) {
        const emptyRow = new Control("emptyRow");
        emptyRow.widthInPixels = 1;
        emptyRow.heightInPixels = this._mesh2D.m2px(Env.broadcast.menu.tipMenu.emptyRow.height);
        innerContainer.addControl(emptyRow);
    }
    _updateTipMenu() {
        this._tipMenuInnerContainer.clearControls();
        this._tipMenuEmptyContainer.isVisible = true;
        if (this._tipMenu === undefined || this._tipMenuEnabled === undefined || !this._tipMenuEnabled)
            return;
        const hasItems = this._tipMenu.length > 0;
        if (hasItems)
            this._addEmptyRow(this._tipMenuInnerContainer);
        for (let item of this._tipMenu) {
            this._addTipMenuItemToContainer(item, this._tipMenuInnerContainer);
        }
        if (hasItems)
            this._addEmptyRow(this._tipMenuInnerContainer);
        this._tipMenuEmptyContainer.isVisible = !hasItems;
    }
    _updateToysMenu() {
        this._toysMenuInnerContainer.clearControls();
        this._toysMenuEmptyContainer.isVisible = true;
        if (this._toysMenu === undefined)
            return;
        const items = this._toysMenu.filter((v) => v.modeDefined !== undefined && (v.token_max === undefined || v.token_max === null || v.token_min <= v.token_max));
        const hasItems = items.length > 0;
        if (hasItems)
            this._addEmptyRow(this._toysMenuInnerContainer);
        for (let item of items) {
            this._addToysMenuItemToContainer(item, this._toysMenuInnerContainer);
        }
        if (hasItems)
            this._addEmptyRow(this._toysMenuInnerContainer);
        this._toysMenuEmptyContainer.isVisible = !hasItems;
    }
}
